import React from 'react';
import iPro from "../img/envision/casestudies/casestudieslogo/fordlogo-removebg-preview.png";
import aCad from "../img/envision/casestudies/casestudieslogo/hirotechlogo-removebg-preview.png";
import nMan from "../img/envision/casestudies/casestudieslogo/itclogo-removebg-preview.png";
import Kuka from "../img/envision/casestudies/casestudieslogo/tatamoterslogo-removebg-preview.png";
import Abb from "../img/envision/casestudies/casestudieslogo/teslalogo-removebg-preview.png";

const Digitalimagestabssingledata = () => {
    return (
        <div style={styles.pageContainer}>
            <div className="container mt-5 pb-5">
                <div className="row justify-content-center" style={{ marginLeft: '50px' }}>
                    <div className="col-12">
                        {/* Images in a row layout */}
                        <div className="row">
                            <div className="col-3 mb-4 d-flex justify-content-center align-items-center">
                                <img src={iPro} alt="iPro" className="img-fluid" style={styles.image} />
                            </div>
                            <div className="col-3 mb-4 d-flex justify-content-center align-items-center">
                                <img src={aCad} alt="aCad" className="img-fluid" style={styles.image} />
                            </div>
                            <div className="col-3 mb-4 d-flex justify-content-center align-items-center">
                                <img src={nMan} alt="nMan" className="img-fluid" style={styles.image} />
                            </div>
                            <div className="col-3 mb-4 d-flex justify-content-center align-items-center">
                                <img src={Kuka} alt="Kuka" className="img-fluid" style={styles.image} />
                            </div>
                        </div>
                        {/* Repeat the row for another set of images All the reality of the protocals remaining   */}

                    </div>
                </div>
            </div>
        </div>
    );
};

// CSS-in-JS Styles
const styles = {
    pageContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#fff', // Light background for the page
    },
    image: {
        height: '120px', // Set image height
        backgroundColor: '#fff', // Background color
        border: '1px solid #000', // Border
        margin: '0px 30px', // Horizontal margin for spacing
        width: '90%', // Set width
        borderRadius: '20px',
    },
};

export default Digitalimagestabssingledata;
